import axios from "axios";

export default function IdentitytypeListService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/identity_type",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
